export default {
    name: "AboutUsSpot",
    props: {
        scrapedAboutUsData: Object
    },
    setup(props){
        return {
            props : props.scrapedAboutUsData
        }
    }
}